module.exports = ".auto-height{\n    height: auto !important;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/popup-modals/info-modal/info-modal.component.css
// module id = 534
// module chunks = 2